module.exports = __webpack_public_path__ + "img/class_PRO.1817496b.jpg";